import VueRouter from 'vue-router';
import routes from './routes';
import store from '../Store/index';

const router = new VueRouter({
  mode: 'history',
  base: process.env.baseUrl,
  routes
});

console.log(process.env.baseUrl, 'process.env.baseUrl');
router.beforeEach((to, from, next) => {
  const parentSlug = to.params.slug;

  if (to.path.startsWith('/centers/') && parentSlug) {
    to.meta.part = parentSlug;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (
      store.state.auth.authenticated ||
      to.name === 'OpenPageLessonGroupEdit' ||
      to.name === 'OpenPageLessonGroupEdit'
    ) {
      next();
      return;
    }
    next({
      path: '/sign-in',
      query: {
        next: to.fullPath
      }
    });
  } else {
    if (
      store.state.auth.authenticated &&
      to.name !== 'EditLessonPage' &&
      to.name !== 'OpenPageLessonGroupEdit'
    ) {
      next('/');
      return;
    }
    next();
  }
});

router.afterEach((to, from) => {});

router.beforeResolve((to, from, next) => {
  next();
});
export default router;
